import { useState, useEffect } from 'react';
import {
	AddServiceAccountType,
	DeleteServiceAccountType,
	GetApplicationManagementByID,
} from '../../_api';
import ServiceAccountForm from '../../components/NewApplication/AppForms/ServiceAccountForm';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import ServiceAccountTypeRequest from '../../../../Classes/ResponseModels/ApplicationManagement/ServiceAccountTypeRequest';
import { ServiceAccountType } from '../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
const ServiceAccountManagement = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [app, setApp] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	//on load, retrieve the AppManagementModel for the selected app
	useEffect(() => {
		GetApplicationManagementByID(appID)
			.then(response => {
				setApp(response);
			})
			.then(x => setIsLoading(false));
	}, [appID]);

	const handleDelete = serviceAccountType => {
		const request = new ServiceAccountTypeRequest(
			currentUser,
			requirementNumber,
			app,
			serviceAccountType
		);
		setIsLoading(true);
		DeleteServiceAccountType(request)
			.then(response => {
				if (response) {
					const updatedServiceAccountTypes = response.map(
						serviceAccountType =>
							new ServiceAccountType(serviceAccountType)
					);
					setApp({
						...app,
						serviceAccountTypes: updatedServiceAccountTypes,
					});
				}
			})
			.then(() => setIsLoading(false));
	};

	const handleSave = serviceAccountType => {
		serviceAccountType.appID = appID;
		const request = new ServiceAccountTypeRequest(
			currentUser,
			requirementNumber,
			app,
			serviceAccountType
		);
		setIsLoading(true);
		AddServiceAccountType(request)
			.then(response => {
				const updatedServiceAccountTypes = response.map(
					serviceAccountType =>
						new ServiceAccountType(serviceAccountType)
				);
				setApp({
					...app,
					serviceAccountTypes: updatedServiceAccountTypes,
				});
			})
			.then(() => setIsLoading(false));
	};

	const actions = serviceAccountType => {
		return (
			<>
				<Button
					startIcon={<MaterialIcon icon='delete' />}
					onClick={e => {
						handleDelete(serviceAccountType);
					}}
					disabled={readOnly && isLoading}
				>
					Delete
				</Button>
			</>
		);
	};

	return (
		<div>
			{isLoading ? (
				<Spinner />
			) : (
				<ServiceAccountForm
					app={app}
					setApp={setApp}
					actions={actions}
					disabled={readOnly}
					handleSaveOverride={handleSave}
					serviceAccountFlowEnabled={
						app.serviceAccountTypes?.length > 0
					}
					disableServiceAccountOnlyToggle={true}
				/>
			)}
		</div>
	);
};

export default ServiceAccountManagement;
